import { render, staticRenderFns } from "./GlobalUserDrawer.vue?vue&type=template&id=2625943a&scoped=true"
import script from "./GlobalUserDrawer.vue?vue&type=script&lang=js"
export * from "./GlobalUserDrawer.vue?vue&type=script&lang=js"
import style0 from "./GlobalUserDrawer.vue?vue&type=style&index=0&id=2625943a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625943a",
  null
  
)

export default component.exports